import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
// tslint:disable-next-line:import-blacklist
import { Observable } from 'rxjs';

import { Product } from './../../common/models/product';
import { mockupProducts } from '../../common/config/mokup-data';
import { promotions } from '../../common/config/promotions';
import { User } from '../../common/models/user';
import { environment } from '../../../environments/environment';
import { Order } from '../../common/models/order';
import { OrderItem } from '../../common/models/orderitem';
import { SessionManager } from '../../common/helpers/session-manager';

// Operators
import 'rxjs/add/operator/map';
import * as _ from 'lodash';
import { forEach } from '@angular/router/src/utils/collection';
import { element } from 'protractor';

@Injectable()
export class ProductService {

  public token: string;
  products: Product[] = [];
  user = new User();
  host = environment.host;
  emblanoUrl = environment.emblanoUrl;
  mockup = [];
  public orderId: string;


  constructor(private http: Http, private sessionManager: SessionManager) { }


  getAllProducts(): Observable<Product[]> {
    return this.http.get(this.host + '/api/product/all', JSON.stringify({}))
      .map((response: Response) => {
        this.products = JSON.parse(response.json());
        const token = response.json() && response.json().token;
        if (token) {
          // set token property
          this.token = token;

          return this.products;
        } else {
          return this.products;
        }
      });
  }

  getGeneratedOrderId(): Observable<any> {
    return this.http.get(this.host + '/api/product/orderId')
    .map((response: Response) => {
      this.orderId = response.json();
    });
  }


  getMemberProducts(customerId: string): Observable<Product[]> {
    return this.http.get(this.host + '/api/product/memberProduct?customerId=' + customerId, JSON.stringify({}))
      .map((response: Response) => {

        this.products = response.json();
        const token = response.json() && response.json().token;
        if (token) {
          // set token property
          this.token = token;
          return this.products;

        } else {
          return this.products;
        }
      });
  }


  public getVisitorProducts(): Observable<Product[]> {
    return this.http.get(this.host + '/api/product/visitorProduct', JSON.stringify({}))
      .map((response: Response) => {

        this.products = response.json();
        const token = response.json() && response.json().token;
        if (token) {
          // set token property
          this.token = token;

          return this.products;
        } else {
          return this.products;
        }
      });
  }


  public getProductsByProductCode(): Observable<Order> {    
    const productOrder = new Order();
    const promoCode = this.sessionManager.getPromoCode();
    if (promoCode) {
    // if (promoCode !== 'undefined' || promoCode != null) {

      // get the productListCode from the promotion list
      const productList = _.find(promotions.products, ['promoCode', promoCode]);

      // const promotionIncludedProuct = _.find(promotions.products, ['productListCode', productListCode]);
      return this.http.get(this.host + '/api/product/productListCode?productListCode=' + productList.productListCode)
        .map((response: Response) => {

          let total = 0;
          let result = response.json();
          let currentDate = new Date();

          this.getGeneratedOrderId().subscribe((response: any) => {
            productOrder.orderId = this.orderId;            
            productOrder.orderDate = currentDate;
            productOrder.orderitems = [];

            result.forEach(productListItem => {
              let orderItem = new OrderItem();
              orderItem.orderItemId = productListItem.productID;
              orderItem.product = productListItem;
              orderItem.productCode = productListItem.productCode;
              orderItem.productName = productListItem.productName;
              orderItem.orderItemPrice = productListItem.price;
              orderItem.orderItemDiscount = productListItem.discount;
              orderItem.orderItemTax = productListItem.tax;
              
              // get the final value of one product
              let valueOfProduct = ((productListItem.price - productListItem.discount) * (1 + productListItem.tax));
              orderItem.orderItemTotal = valueOfProduct;
              total = total + valueOfProduct;
              productOrder.orderitems.push(orderItem);

            });
            productOrder.orderTotal = total;
            this.sessionManager.setShoppingCartData(productOrder);
          });
          return productOrder;
        });
    }
  }

   public getProductsByPriceListId(productPriceListId: string): Observable<Order> {
          const productOrder = new Order();
          // get the productListCode from the promotion list
          // const promotionIncludedProuct = _.find(promotions.products, ['productListCode', productListCode]);
            return this.http.get(this.host + '/api/product/productListCode?createModifiedOrder=' + productPriceListId)
              .map((response: Response) => {
                let total = 0;
                // tslint:disable-next-line:prefer-const
                let result = response.json();
                // genarate order id

                // tslint:disable-next-line:prefer-const
                let currentDate = new Date();
                // tslint:disable-next-line:no-shadowed-variable
                this.getGeneratedOrderId().subscribe((response: any) => {
                  productOrder.orderId = this.orderId;
                  console.log( productOrder.orderId);
                  productOrder.orderDate = currentDate;
                  productOrder.orderitems = [];
                  result.forEach(productListItem => {
                    // tslint:disable-next-line:prefer-const
                    let orderItem = new OrderItem();
                    orderItem.orderItemId = productListItem.productID;
                    orderItem.product = productListItem;
                    orderItem.productCode = productListItem.productCode;
                    orderItem.productName = productListItem.productName;
                    orderItem.orderItemPrice = productListItem.price;
                    orderItem.orderItemDiscount = productListItem.discount;
                    orderItem.orderItemTax = productListItem.tax;
                    productOrder.orderitems.push(orderItem);
                    // get the final value of one product
                    // tslint:disable-next-line:prefer-const
                    let valueOfProduct = ((productListItem.price - productListItem.discount) * (1 + productListItem.tax));
                    console.log(valueOfProduct);
                    total = total + valueOfProduct;
                  });
                  productOrder.orderTotal = total;
                  console.log(total);
                  this.sessionManager.setShoppingCartData(productOrder);
                });
                return productOrder;
              });
         }
  }



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/shopping-cart/services/product.service.ts